<template>
  <div>
    <ContentHeader title="Manager Cabang" />
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-primary">
              <form @submit.prevent="handleCreateData()" class="card-body">
                <div class="mb-3">
                  <label for="password">New Password</label>
                  <div class="input-group mb-0">
                    <input
                      :type="show.password ? 'text' : 'password'"
                      class="form-control border-end-0"
                      id="password"
                      placeholder="New Password"
                      :class="{ 'border-danger': $v.payload.password.$error }"
                      v-model="payload.password"
                    />
                    <div class="input-group-append">
                      <div
                        class="input-group-text bg-white border-start-0"
                        :class="{ 'border-danger': $v.payload.password.$error }"
                        @click="showPassword()"
                      >
                        <span
                          class="fas"
                          :class="{
                            'fa-eye': !show.password,
                            'fa-eye-slash': show.password,
                          }"
                        ></span>
                      </div>
                    </div>
                  </div>
                  <div class="text-danger" v-if="$v.payload.password.$error">
                      <small v-if="!$v.payload.password.required">Password is Required</small>
                      <small v-if="!$v.payload.password.minLength">Password must have at {{$v.payload.password.$params.minLength.min}} Least</small>
                  </div>
                </div>

                <div class="mb-3">
                  <label for="confirm-new-password">Confirm New Password</label>
                  <div class="input-group mb-0">
                    <input
                      :type="show.confirm_password ? 'text' : 'password'"
                      class="form-control border-end-0"
                      id="confirm-new-password"
                      placeholder="Confirm New Password"
                      :class="{
                        'border-danger':
                          $v.payload.confirm_password.$error ||
                          !$v.payload.confirm_password.sameAsPassword,
                      }"
                      v-model="payload.confirm_password"
                    />
                    <div class="input-group-append">
                      <div
                        class="input-group-text bg-white border-start-0"
                        :class="{
                          'border-danger': $v.payload.confirm_password.$error,
                        }"
                        @click="showConfirmPassword()"
                      >
                        <span
                          class="fas"
                          :class="{
                            'fa-eye': !show.confirm_password,
                            'fa-eye-slash': show.confirm_password,
                          }"
                        ></span>
                      </div>
                    </div>
                  </div>
                  <div class="text-danger" v-if="$v.payload.confirm_password.$error">
                    <small v-if="!$v.payload.confirm_password.required">Confirm Password is Required</small>
                    <small v-if="!$v.payload.confirm_password.minLength">Confirm Password must have at {{$v.payload.confirm_password.$params.minLength.min}} Least</small>
                    <div class="text-danger" v-if="!$v.payload.confirm_password.sameAsPassword">
                      <small>Password must be Identical</small>
                    </div>
                  </div>
                </div>

                <div class="card-footer">
                  <router-link
                    class="btn btn-outline-danger mr-3"
                    :to="{ name: 'Profile' }"
                    v-if="!userFieldStatus"
                  >
                    Back
                  </router-link>
                  <button
                    type="submit"
                    href="#"
                    class="btn btn-success btn-block"
                    :disabled="submitStatus === 'PENDING'"
                  >
                    Change Password
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import apiClient from "../../services/ApiServices";
import ContentHeader from "@/components/molecules/ContentHeader.vue";
import { required,minLength, sameAs } from "vuelidate/lib/validators";

export default {
  components: {
    ContentHeader,
  },
  data() {
    return {
      payload: {
        password: "",
        confirm_password: "",
      },
      show: {
        password: false,
        confirm_password: false,
      },
      submitStatus : '',
    };
  },
  validations: {
    payload: {
      password: {
        required,
        minLength: minLength(8)
      },
      confirm_password: {
        required,
        minLength:minLength(8),
        sameAsPassword: sameAs("password"),
      },
    },
  },
  computed: {
    userFieldStatus() {
      return this.$store.getters.userFieldStatus;
    },
  },
  methods: {
    showPassword() {
      this.show.password = !this.show.password;
    },
    showConfirmPassword() {
      this.show.confirm_password = !this.show.confirm_password;
    },
    handleCreateData() {
      let data = new FormData();
      // data.append("username", this.payload.username);
      data.append("password", this.payload.password);

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.submitStatus = "PENDING";

        apiClient
          .put(`${this.$route.params.id}/`, data)
          .then(() => {
            this.submitStatus = "OK";

            this.$swal(
              "Changed!",
              "Password Has Been Changed.",
              "success"
            ).then(() => {
              this.submitStatus = "OK";
              this.errorMessage = "";
              this.$router.push({ name: "Profile" });
            });
          })
          .catch((error) => {
            this.submitStatus = "ERROR";

            this.$swal("Fail!", error.data.message, "error").then(() => {
              this.submitStatus = "ERROR";
              this.errorMessage = "";
            });
          });
      }
    },
  },
};
</script>

<style scoped>
@media only screen and (max-width: 600px) {
  .card-footer {
    flex-direction: column-reverse;
  }
  .card-footer > .btn {
    margin-bottom: 0.5rem;
  }
}
</style>